import { ChatPromptType } from '../constants/cia';
import type { ICiaAgent, ICiaGenerativeOption, ICiaResult } from '../types/cia';

const parseAgentsXml = (xml: string): ICiaAgent[] => {
  if (!xml) {
    return [];
  }

  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xml, 'text/xml');

  const agentNodes = Array.from(
    xmlDoc.querySelectorAll('ArrayOfAgent > Agent')
  );

  return agentNodes
    .map(agentNode => {
      const id = agentNode.querySelector('Id')?.textContent || '';
      const name = agentNode.querySelector('Name')?.textContent || '';
      const description =
        agentNode.querySelector('Description')?.textContent || '';
      const agentXml = new XMLSerializer().serializeToString(agentNode);

      const rights = Array.from(agentNode.querySelectorAll('Rights string'))
        .map(right => right.textContent?.trim() || '')
        .filter(Boolean);

      return {
        id,
        name,
        description,
        xml: agentXml,
        rights,
        hasRights: true,
      };
    })
    .filter(agent => agent.id && agent.name);
};

const parseGenerativeOptionsXml = (xml: string): ICiaGenerativeOption[] => {
  if (!xml) {
    return [];
  }

  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xml, 'text/xml');

  const parserError = xmlDoc.getElementsByTagName('parsererror')[0];

  if (parserError) {
    console.error(
      'Erro ao fazer parse do XML das opções generativas:',
      parserError.textContent
    );
    return [];
  }

  const command = xmlDoc.getElementsByTagName('Command')[0]?.textContent || '';
  const errorMessage =
    xmlDoc.getElementsByTagName('ErrorMessage')[0]?.textContent || '';

  if (command) {
    console.log('Cia Generative Menu - Command:', command);
  }

  if (errorMessage) {
    console.error('Cia Generative Menu - ErrorMessage:', errorMessage);
    return [];
  }

  const contents = Array.from(xmlDoc.getElementsByTagName('string'));

  return contents
    .map(node => node.textContent || '')
    .map(content => content.trim())
    .filter(Boolean)
    .map(content => {
      const separatorIndex = content.indexOf('=');

      if (separatorIndex === -1) {
        return {
          key: '',
          value: '',
        };
      }

      const key = content.substring(0, separatorIndex).trim();
      const value = content.substring(separatorIndex + 1).trim();

      return {
        key,
        value,
      };
    })
    .filter(option => option.key && option.value);
};

const parseChatPromptResultXml = (xml: string): ICiaResult => {
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xml, 'text/xml');

  const command = xmlDoc.getElementsByTagName('Command')[0]?.textContent || '';
  const errorMessage =
    xmlDoc.getElementsByTagName('ErrorMessage')[0]?.textContent || '';
  const resultant =
    xmlDoc.getElementsByTagName('Resultant')[0]?.textContent || '';

  return {
    success: !errorMessage,
    message: command,
    errorMessage,
    resultant: Object.values(ChatPromptType).includes(
      resultant as ChatPromptType
    )
      ? (resultant as ChatPromptType)
      : undefined,
  };
};

const buildAgentInvokerXml = (xml: string): string => {
  const xmlDoc = document.implementation.createDocument('', '', null);
  const root = xmlDoc.createElement('ChatPromptResult');

  const appendElement = (name: string, value: string) => {
    const element = xmlDoc.createElement(name);
    element.textContent = value;
    root.appendChild(element);
  };

  appendElement('Type', 'Agent');
  appendElement('Resultant', 'Agent');
  appendElement('Command', xml);

  xmlDoc.appendChild(root);

  return new XMLSerializer().serializeToString(xmlDoc);
};

export {
  parseAgentsXml,
  parseGenerativeOptionsXml,
  parseChatPromptResultXml,
  buildAgentInvokerXml,
};
